import Copy from './DataProcessesCopy'
import Edit from './DataProcessesEdit'
import Main from './DataProcessesMain'
import New from './DataProcessesNew'
import View from './DataProcessesView'
import Remove from './DataProcessesRemove'

const DataProcesses = {
  Copy,
  Edit,
  Main,
  New,
  Remove,
  View,
}

export default DataProcesses
